export const BackEndpath = "https://oreta.org";
export const MicrosoftAuthUri = "https://oreta.org/login";

